import { render, staticRenderFns } from "./TasteSolutions.vue?vue&type=template&id=60c8d59a&scoped=true&"
import script from "./TasteSolutions.vue?vue&type=script&lang=js&"
export * from "./TasteSolutions.vue?vue&type=script&lang=js&"
import style0 from "./TasteSolutions.vue?vue&type=style&index=0&id=60c8d59a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c8d59a",
  null
  
)

export default component.exports